import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

import { Dictionary } from '../types/types';

export interface QuestionType {
   type: string
   id: number
   required: boolean
   answers: Dictionary
   uploads: number
}

interface Questions {
   questions: QuestionType[]
}


interface QuestionAction {
   setQuestions: (questions: QuestionType[]) => void
   upsertQuestion: (question: QuestionType) => void
   updateQuestion: (id: number, question: QuestionType) => void
   removeQuestion: (id: number) => void
   removeQuestions: () => void
};

export const useQuestionStore = create<Questions & QuestionAction>()(
   persist(
   (set) => ({
      questions: [],
      setQuestions: (questions)=> set(()=>({questions:[...questions]})),
      upsertQuestion: (question)=> set((state)=>({questions: [...state.questions.filter((q)=>question.id!==q.id), question]})),
      updateQuestion: (id, question) => set((state) => {
         return {questions:state.questions.map((q)=>{
            //protect id
            return q.id === id?{...question, id:id} :q;
         })}
      }),
      removeQuestion: (id: number) => set((state) => ({questions:state.questions.filter((_, i)=>id!==i)})),
      removeQuestions: () => set(() => ({questions:[]}))
   }),
   {
      name: 'questions',
      storage: createJSONStorage(() => sessionStorage), // (optional) by default, 'localStorage' is used
   })
);
